<template>
  <v-container fluid tag="section" class="px-0">
    <div v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <v-card-text class="py-0" v-for="(itm,idx) in item" :key="idx">
      <div class="mb-2">
        <span class="mr-1 primary--text">【{{itm.createUser.name}}】</span>
        于
        <span class="mx-1">{{itm.createTime | formatDate}}</span>
        移交给了
        <span class="mx-1 green--text">【{{itm.toUser.name}}】</span>
        移交前负责人
        <span class="mx-1 grey--text">【{{itm.fromUser.name}}】</span>
      </div>
    </v-card-text>
  </v-container>
</template>

<script>
  export default {
    name: 'CustomerMoveRecord',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      }
    },
    data() {
      return {
        form: {
          id: '',
          result: ''
        }
      }
    }
  }
</script>

<style>
</style>
